import { render, staticRenderFns } from "./typeCBtn.vue?vue&type=template&id=1c8e8409"
import script from "./typeCBtn.vue?vue&type=script&lang=js"
export * from "./typeCBtn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports